export const AppRoutes = {
  home: '/',
  mobileDevelopment: '/mobile-development',
  frontend: '/front-end-development',
  backend: '/back-end-development',
  devOps: '/devops-services',
  aboutUs: '/about-us',
  career: '/career',
  partnership: '/your-trusted-partner-for-expert-solutions',
  approach: '/agile-project-management-approach',
  netPage: '/back-end-development/dot-net-solutions',
  iosPage: '/mobile-development/ios',
  lawyersPage: '/portfolio/custom-legal-software-development-services',
  bookingApplicationPage: '/portfolio/desk-booking-app-development-services',
  bookingSolutionPage: '/portfolio/booking-solution',
  marketAnalysisPage: '/portfolio/market-analysis',
  streamingAppPage: '/portfolio/streaming-app',
  smartCityPage: '/portfolio/smart-city',
  trackingAppPage: '/portfolio/tracking-app',
  developYourProduct: '/develop-your-product',
  scaleYourTeam: '/scale-your-team',
  news: '/news',
  blog: '/blog',
  realEstateSearchApp: '/portfolio/real-estate-search-app',
  customRealEstateSoftwareSolution:
    '/portfolio/custom-real-estate-software-solution',
  newYearParty: '/news/new-year-party',
  topTrends: '/blog/top-development-trends',
  portfolio: '/portfolio',
  polotskMeetUp: '/news/polotsk-meet-up',
  nextBlockExpo2023: '/news/next-block-expo-2023',
  businessMustHave: '/blog/business-must-haves',
  xaas: '/blog/what-is-xaas',
  tenMistakes: '/blog/ten-mistakes',
  mobileAppTrends: '/blog/mobile-app-trends',
  ukraineSupport: '/news/stand-with-ukraine',
  onlinePresentation: '/news/online-presentation',
  smsEmailCommunicationApp: '/portfolio/sms-email-communication-app',
  dataPrivacy: '/blog/data-privacy',
  geographicallyDistributedTeams:
    '/blog/geographically-distributed-development-teams',
  meetUpItCommunity: '/news/meet-up-it-community',
  portalForEducation: '/portfolio/portal-for-education',
  legalServiceApp: '/portfolio/legal-service-app',
  deliveryManagementApp: '/portfolio/delivery-management-app',
  aprilTeamBuilding: '/news/april-team-building',
  appForInternationalPayments: '/portfolio/app-for-international-payments',
  hedgeAccountingSoftware: '/portfolio/hedge-accounting-software',
  aiBasedlogisticsplatform: '/portfolio/ai-powered-logistics-platform',
  truckBookingMonitoringPlatform:
    '/portfolio/truck-booking-and-monitoring-platform',
  carRentalApp: '/portfolio/car-rental-app',
  medicalCardsApp: '/portfolio/web-app-for-medical-cards-storage',
  sellingProductsServicesBusinesses:
    '/portfolio/selling-products-services-businesses',
  bankingServices: '/portfolio/banking-services',
  mobileMarketplace: '/portfolio/cross-platfrom-mobile-app-development',
  interserviceApp: '/portfolio/interservice-app',
  cryptocurrency: '/portfolio/cryptocurrency',
  businessLoans: '/portfolio/business-loans',
  telehealthSoftware: '/portfolio/telemedicine-software-platform',
  applicationForMedicalEquipmentProvision:
    '/portfolio/application-for-medical-equipment-provision',
  modsenInTopLists: '/news/modsen-in-top-lists',
  iotDeviceManagement: '/portfolio/internet-of-things-software',
  adTechCases: '/portfolio?domain=AdTech',
  mobileBankingDevelopment: 'blog/mobile-banking-development',
  modsenTopFintech: '/news/modsen-top-financial-technology',
  fintechMobileApp: '/blog/financial-technology-mobile-app',
  dotnetTechnogolyEssentials:
    '/blog/net-technology-essentials-for-developers-and-businesses',
  upcomingFrontendTrends: '/blog/upcoming-frontend-trends',
  reactNativeDevelopment: '/blog/rn-development',
  blockchainGettingStartedWithFintech:
    '/blog/blockchain-getting-started-fintech',
  augmentationVendor: '/augmentation-vendor',
  augmentationVendorThanks: '/augmentation-vendor/thanks',
  fintech: '/fintech',
  enterprise: '/enterprise',
  medtech: '/medtech',
  socialNetworking: '/social-networking',
  logistics: '/logistics',
  travel: '/travel',
  iot: '/iot',
  adTech: '/ad-tech',
  edTech: '/edtech',
  agriculture: '/agriculture-solution-development',
  ios: '/mobile-development/ios',
  android: '/mobile-development/android-developers',
  reactNative: '/mobile-development/react-native',
  flutter: '/mobile-development/flutter-solutions',
  modsenNetTechTalksHackathon: '/news/modsen-net-tech-talks-hackathon',
  angular: '/front-end-development/angular-solutions',
  react: '/front-end-development/react-solutions',
  vue: '/front-end-development/vuejs-solutions',
  nodejs: '/back-end-development/nodejs-solutions',
  java: '/back-end-development/java-application-development-services',
  python: '/back-end-development/python-solutions',
  php: '/back-end-development/php-application-development',
  letsWork: '/lets-work',
  monitoring: '/monitoring',
  designStudio: '/design-studio',
  ctoStaffService: '/blog/staff-augmentation-service',
  privacyPolicy: '/privacy-policy',
  qualityAssurance: '/quality-assurance-services',
  certificateFound: '/certificate-found',
  certificateNotFound: '/certificate-not-found',
  certifications: '/certifications',
  cloud: '/devops-services/devops-and-cloud-computing',
  cicd: '/devops-services/ci-cd-integration',
  iaas: '/devops-services/iaas-solutions',
  orchestration: '/devops-services/orchestration-solutions',
  gamingIndustryBlog: 'https://techjury.net/blog/gaming-industry-worth/#gref',
  portfolioGamedev: '/portfolio?domain=GameDev',
  populationResearch:
    'https://population.un.org/wpp/Publications/Files/WPP2019_10KeyFindings.pdf',
  unicefResearch:
    'https://data.unicef.org/resources/sofi-2022/#:~:text=The%202022%20edition%20of%20The,shocks%2C%20combined%20with%20growing%20inequalities0',
  portfolioMonitoring: '/portfolio/monitoring',
  portfolioDataManagement:
    '/portfolio/agricultural-data-management-automation-software',
  agricultureSuccess: '/portfolio?page=1&domain=Agriculture',
  perfectProject: '/blog/perfect-project',
  grandViewResearch:
    'https://www.grandviewresearch.com/industry-analysis/artificial-intelligence-ai-market',
  mcKinseySurvey:
    'https://www.mckinsey.com/capabilities/quantumblack/our-insights/the-state-of-ai-in-2022-and-a-half-decade-in-review',
  capGeminiResearch:
    'https://www.capgemini.com/news/press-releases/research-ai-in-customer-experience/',
  gartnerPredicting:
    'https://www.gartner.com/en/newsroom/press-releases/2022-07-27-gartner-predicts-chatbots-will-become-a-primary-customer-service-channel-within-five-years',
  improvingDiagnosticAccuracy:
    '/portfolio/platform-for-improving-diagnostic-accuracy',
  successStoriesEnterprise: '/portfolio?page=1&domain=Enterprise',
  PortfolioLogisticsIOT:
    '/portfolio/iot-platform-for-logistics-it-solutions-provider',
  portfolioAutomatedFinancialReportingSoftware:
    '/portfolio/automated-financial-reporting-software',
  documentProcessingMachineLearningFinance:
    '/portfolio/document-processing-machine-learning-finance-case-study',
  aiBasedInvestmentMonitoringPlatform:
    '/portfolio/ai-based-investment-monitoring-platform',
  eCommerceTransformationAiComputerVisionBiPlatform:
    '/portfolio/e-commerce-transformation-ai-computer-vision-bi-platform',
  bigDataSolutionForOnlineBank: '/portfolio/big-data-solution-for-online-bank',
  bigDataMedicalRecordSystemLayout:
    '/portfolio/big-data-medical-record-system-layout',
  modsenInstagram: 'https://www.instagram.com/modsencompany',
  modsenLinkedIn: 'https://www.linkedin.com/company/modsen',
  modsenFacebook: 'https://www.facebook.com/ModsenSoftware',
  modsenTwitter: 'https://twitter.com/modsencompany',
  modsenDribbble: 'https://dribbble.com/ModsenDesign',
  blockchainBasedPaymentSolutions:
    '/portfolio/blockchain-payment-cross-border-solution',
  blockchainDigitalIdentitySolution:
    '/portfolio/blockchain-digital-identity-solution',
  buildingEcommerceSiteElectronicRetailer:
    '/portfolio/building-ecommerce-site-electronic-retailer',
  design991: '/portfolio/design-991',
  resourceAppLayout: '/portfolio/resource-app-layout',
  businessAnalysisServices: '/business-analysis-services',
  healthcare: '/healthcare',
  portfolioHealthcare: '/portfolio?domain=Healthcare',
  smartIoTAppFitnessCenters: '/portfolio/smart-iot-app-fitness-centers',
  mobileAppEventDiscoveryAndTaxiBooking:
    '/portfolio/mobile-app-for-local-event-discovery-and-taxi-booking',
  ioTDeviceManagementPlatform: '/portfolio/iot-device-management-platform',
  improvingRoi: '/portfolio/in-vehicle-targeted-advertising-solution',
  aiPoweredPlatform: '/portfolio/ai-powered-platform-for-patient-diagnosing',
  hotelMobileApp:
    '/portfolio/full-stack-engineer-for-mobile-back-end-overhaul-hotel-app',
  vacancyPython: '/career/data-python-engineer',
  telemedicine: '/portfolio/telemedicine-software-platform',
  heathcareSoftwareDevelopment:
    '/portfolio/being-well-with-heathcare-software-solutions',
  staffAugmentationServices:
    '/portfolio/staff-augmentation-services-for-custom-app-development',
  staffAugmentationServicesForEducation:
    '/portfolio/staff-augmentation-services-for-education-software-development  ',
  adAnalytics: '/portfolio/ad-analytics-platform',
  videoAdvertising: '/portfolio/video-advertising-platform',
  vacancyManagement: '/portfolio/vacancy-management-software',
  staffAugmentationForStoreScaling:
    '/portfolio/staff-augmentation-for-online-store-scaling',
  portfolioDataManagementSoftware: '/portfolio/farm-data-management-software',
  growingMoreWithLess: '/blog/growing-more-with-less',
  agileMethodologies: '/blog/agile-methodologies',
  successStaffAugmentation: '/portfolio?page=1&domain=Staff+Augmentation',
  portfolioFoodDelivery:
    '/portfolio/food-delivery-cross-platform-app-development',
  smartContractDevelopment: '/blog/smart-contract-development',
  microsoftPartner: '/blog/microsoft-partner',
  financialManagementSoftwareDev:
    '/blog/financial-management-software-development',
  peerToPeerLending: '/blog/peer-to-peer-lending',
  centerStageEfficiency: '/blog/center-stage-efficiency',
  blockchainTechAndSmartContracts:
    '/blog/blockchain-technology-and-smart-contracts',
  web3VsCentralizedFinanceBanking: '/blog/web3-vs-centralized-finance-banking',
  crackingDataScienceCodeBusinessInsights:
    '/blog/cracking-data-science-code-business-insights',
  newHeadDotNet: '/blog/new-head-dotnet-development-modsen',
  digitalTransformationAutomationAi:
    '/blog/digital-transformation-and-automation-with-ai',
  aiImpactBusinessLandscape: '/blog/ai-impact-business-landscape',
  howModsenHandlesMobileAppDevRisks:
    '/blog/how-modsen-handles-mobile-app-development-risks',
  gameDev: '/blog/gamedev',
  newHeadJsDevDepartment: '/blog/new-head-of-js-development-department',
  javaDestiny: '/blog/java-destiny',
  iotSoftware: '/blog/iot-software',
  mustHaveFeaturesRestaurantsMobileApp:
    '/blog/must-have-features-for-your-restaurants-mobile-app',
  newCto: '/blog/new-cto',
  reactNativeNews: '/blog/react-native-news',
  topTierSoftwareDevPartner: '/blog/top-tier-software-dev-partner',
  chatGpt: '/blog/chat-gpt',
  ctoBestRecruiter: '/blog/cto-best-recruiter',
  cyberSecurityAi: '/blog/cybersecurity-and-ai',
  whatIsAdTech: '/blog/what-is-ad-tech',
  whatsBehindAllHypePython: '/blog/whats-behind-all-hype-about-python',
  modsenWrappingUp2022: '/blog/modsen-wrapping-up-2022',
  modsenNetDev: '/blog/modsen-net-development',
  hiringFullstackDev: '/blog/hiring-fullstack-developer',
  tenMythsItStaff: '/blog/ten-myths-about-it-staff',
  howToEnsureQualityMonitoringOfAnOutstaffProjectTeam:
    '/blog/how-to-ensure-quality-monitoring-of-an-outstaff-project-team',
  signsAugmentationStaffServiceWhatYouNeed:
    '/blog/signs-augmentation-staff-service-is-what-you-need',
  howModsenPullsMajorStaffAugmentationChallenges:
    '/blog/how-modsen-pulls-off-major-staff-augmentation-challenges',
  smartTechsYourBusiness: '/blog/smart-technologies-of-your-business',
  bigDataManagementInBaking: '/blog/big-data-management-in-banking',
  financialServicesIndustry: '/blog/financial-services-industry',
  mobileBakingDev: '/blog/mobile-banking-development',
  internetOfThings: '/blog/internet-of-things',
  beingWellWithHeatcareSoftwareSolutions:
    '/blog/being-well-with-heathcare-software-solutions',
  streamliningBusinessProcessesSmartContracts:
    '/blog/streamlining-business-processses-with-smart-contracts',
  ceoRecap2023: '/blog/ceo-recap-2023',
  earlyTesting: '/blog/early-testing',
  scmSoftwareWithConfidence: '/blog/scm-software-with-confidence',
  web3AsUltimateStageInternetEvolution:
    '/blog/web3-as-an-ultimate-stage-of-internet-evolution',
  leveragingAiDataScience: '/blog/leveraging-ai-and-data-science',
  whyCrmIsJustRight: '/blog/why-crm-is-just-right',
  crossPlatformingWithRn: '/blog/cross-platforming-with-react-native',
  allYouNeedToKnowAboutFlutterCraftingApps:
    '/blog/all-you-need-to-know-about-flutter-crafting-cross-platform-apps',
  erpSolutionsForBusiness: '/blog/erp-solutions-for-business',
  vacancy: '/vacancy',
  fintechCases: '/portfolio?domain=Fintech',
  portfolioCrmImplementation: '/portfolio/crm-implementation',
  portfolioCrmSoftwareFoodIndustry: '/portfolio/crm-software-for-food-industry',
  portfolioInternalAirlineApp: '/portfolio/internal-airline-app',
  portfolioErpSoftwareChemical: '/portfolio/erp-software-for-chemical',
  portfolioCrossPlatformPaymentAppDev:
    '/portfolio/cross-platform-payment-app-development',
  portfolioMobileAppsInternetBanking: '/portfolio/mobile-apps-internet-banking',
  portfolioWirelessSensorSystemPckgCmp:
    '/portfolio/wireless-sensor-system-for-packaging-company',
  portfolioTourBookingSoftwareDev:
    '/portfolio/tour-booking-software-development',
  IoTCases: '/portfolio?domain=IoT',
  portfolioIotRetailers: '/portfolio/iot-for-retailers',
  portfolioIotSaas: '/portfolio/iot-saas-based',
  modsenPresentation: '/news/modsen-presentation',
  halloweenParty: '/news/modsen-halloween-party',
  itCareerDev: '/news/it-career-development',
  septemberModsenTechTalks: '/news/september-modsen-tech-talks',
  designRushRecommendsModsen: '/news/designrush-recommends-modsen',
  modsenNetTechTalks: '/news/modsen-net-tech-talks',
  onlineMeetupsFutureDevs: '/news/online-meetups-for-future-developers',
  modsenSummerParty: '/news/modsen-summer-party-2022',
  bestDev2022MultipleNominations:
    '/news/best-developer-2022-in-multiple-nominations',
  modsenIsWinnerFintechAwards2022:
    '/news/modsen-is-a-winner-of-the-fintech-awards-2022',
  bestRnDev: '/news/the-best-react-native-developer',
  portfolioMedicalCardsApp: '/portfolio/medical-cards-app',
  digitalTransformation: '/portfolio/digital-transformation',
  inHouseTeamAugmentationCustomApp:
    '/portfolio/in-house-team-augmentation-for-custom-app',
  intranetSoftwareHomeAppManufacturer:
    '/portfolio/intranet-software-for-home-appliance-manufacturer',
  corporatePlatformFinancialCompany:
    '/portfolio/corporate-platform-for-financial-company',
  appServerRedesignUpdate: '/portfolio/app-server-redesign-and-update',
  tradingEducationPlatform: '/portfolio/trading-education-platform',
  distanceLearningPlatform: '/portfolio/distance-learning-platform',
  salePurchasePlatform: '/portfolio/sale-purchase-platform',
  emergencyServicesManagementSoftwareDev:
    '/portfolio/emergency-services-management-software-development',
  wageAccessPLatform: '/portfolio/wage-access-platform',
  smartSystemGamer: '/portfolio/smart-system-for-gamer',
  vrApp: '/portfolio/vr-technology-for-heavy-industry',
  videoSurveillanceVrAPP: '/portfolio/video-surveillance-vr-app',
  fashionEcommercePlatform: '/portfolio/fashion-ecommerce-platform',
  smsBusinessMsgFinance: '/portfolio/sms-business-messaging-for-finance',
  posMobileApp: '/portfolio/pos-mobile-app',
  enhancedTrainTravel:
    '/portfolio/train-travel-application-modernization-loyalty-programs',
  efficientHotelSoftwareDevelopment:
    '/portfolio/full-stack-developer-for-hotel-software-development',
  mahouSan: 'https://www.mahou-sanmiguel.com/en-gb',
  amazon: 'https://www.amazon.com/',
  javaApplicationDevelopmentServices:
    '/back-end-development/java-application-development-services',
  yourTrustedPartner: '/your-trusted-partner-for-expert-solutions',
  legalAppModernizationServices: '/portfolio/legal-app-modernization-services',
  portfolioDeskBookingMobileApp: '/portfolio/desk-booking-mobile-application',
  intranetEducationCompany: '/portfolio/intranet-portal-for-education-company',
  thankYou: '/thank-you',
  portfolioPredictiveAnalyticsForGaming:
    '/portfolio/predictive-analytics-for-gaming',
  vrSoftwareDevelopmentServices: '/portfolio/vr-software-development-services ',
  interviewWithHeadHR: '/blog/interview-with-head-hr',
  cropDeliveryAndProcessingSolution:
    '/portfolio/crop-delivery-and-processing-solution',
  wrappingUp2023WithCTO: '/blog/modsen-wrapping-up-2023-with-cto',
  agileProjectManagement: '/agile-project-management',
  sustainableSoftwareDevelopment: '/sustainable-software-development',
  rampingUpTheLimits: '/blog/ramping-up-the-limits',
  medtech2024TrendsInsights: '/blog/medtech-2024-trends-insights',
  aiDrivenCustomerExperienceSolutionForAirlines:
    '/portfolio/ai-driven-customer-experience-solution-for-airline-logistics',
  dataSecurityInterview: '/blog/data-security-interview-with-modsen-cto',
  startupChallengesAndSolutions: '/blog/startup-challenges-and-solutions',
  startupFailureRate: 'https://www.failory.com/blog/startup-failure-rate',
  aiPoweredVirtualAssistantForWarehouseManagement:
    '/portfolio/ai-powered-virtual-assistant-for-warehouse-management',
  potrfolioIotSoftwareForTrucking: '/portfolio/iot-software-for-trucking',
} as const
